import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* eslint-disable */
export default new Router({
    routes: [{
        path: "/main",
        name: "main",
        component: () =>
            import("./views/home/main.vue")
    },
    {
        path: "/",
        name: "callBack",
        component: () =>
            import("./views/callBack.vue")
    },
    {
        path: "/home",
        name: "home",
        component: () =>
            import("./views/home/home.vue")
    },
    {
        path: "/login",
        name: "login",
        component: () =>
            import ("./views/login/login.vue")
    },
    /**---账号管理列表---**/
    {
        path: "/accountManageList",
        name: "accountManageList",
        component: () =>
            import("./views/accountManage/accountManage/accountManageList.vue")
    },
    /**---账号管理详情---**/
    {
        path: "/accountManageDetail/:type",
        name: "accountManageDetail",
        component: () =>
            import("./views/accountManage/accountManage/accountManageDetail.vue")
    },
    /**---账号管理编辑---**/
    {
        path: "/accountManageEdit",
        name: "accountManageEdit",
        component: () =>
            import("./views/accountManage/accountManage/edit.vue")
    },
    /**---角色管理列表---**/
    {
        path: "/roleManageList",
        name: "roleManageList",
        component: () =>
            import("./views/accountManage/roleManage/roleManageList.vue")
    },
    /**---角色管理详情---**/
    {
        path: "/roleManageDetail/:type",
        name: "roleManageDetail",
        component: () =>
            import("./views/accountManage/roleManage/roleManageDetail.vue")
    },
    {
        path: "/roleDetail/:type",
        name: "roleDetail",
        component: () =>
            import("./views/accountManage/roleManage/detail.vue")
    },
    // 企业组织管理
    {
        path: "/organizationManage",
        name: "organizationManage",
        component: () =>
            import("./views/organizationManage/organizationList.vue")
    },
    {
        path: "/organizationEdit",
        name: "organizationEdit",
        component: () =>
            import("./views/organizationManage/edit.vue")
    },
    {
        path: "/organizationDetail",
        name: "organizationDetail",
        component: () =>
            import("./views/organizationManage/organizationDetail.vue")
    },
    // 岗位详情
    {
        path: "/stationDetail",
        name: "stationDetail",
        component: () =>
            import("./views/organizationManage/stationDetail.vue")
    },
    {
        path: "/stationEdit",
        name: "stationEdit",
        component: () =>
            import("./views/organizationManage/stationEdit.vue")
    },
    /**---资源管理---**/
    {
        path: "/resourceManage",
        name: "resourceManage",
        component: () =>
            import("./views/systemManage/resourceManage/resourceManage.vue")
    },
    {
        path: "/resourceEdit",
        name: "resourceEdit",
        component: () =>
            import("./views/systemManage/resourceManage/edit.vue")
    },
    // 证大跳转空页面路由
    {
        path: "/unionLogin",
        name: "unionLogin",
        component: () =>
            import("./views/callBack.vue")
    },
    // 下载页面
    {
        path: "/download",
        name: "download",
        component: () =>
            import("./views/downloadPages/download.vue")
    },
    {
        path: "/reportList",
        name: "reportList",
        component: () =>
            import("./views/reportServer/list.vue")
    },
    {
        path: "/table",
        name: "table",
        component: () =>
            import("./views/table.vue")
    },
    /**---预警管理---**/
    {
        path: "/earlywarning",
        name: "earlywarning",
        component: () =>
            import("./views/warningManage/index.vue")
    },
    {
        path: "/editearlywarning",
        name: "editearlywarning",
        component: () =>
            import("./views/warningManage/edit.vue")
    },
    {
        path: "/imgSetter",
        name: "imgSetter",
        component: () =>
            import("./views/home/imgSetter.vue")
    },
    /**日志管理 */
    {
        path: '/loginLog',
        name: "loginLog",
        component: () =>
            import("./views/logManage/loginlog.vue")
    },
    {
        path: "/workLog",
        name: "workLog",
        component: () =>
            import("./views/logManage/workLog.vue")
    },
    {
        path: '/paymentLogin',//缴费登录
        name: 'paymentLogin',
        component: () => import('./views/Payment/Login/Login.vue')
    },
    //定金缴费
    {
        path: '/Depositlist',//缴费清单
        name: 'Depositlist',
        component: () => import('./views/Payment/contract-manage/Depositlist.vue')
    },
    //未缴费清单 Unpaidlist
    {
        path: '/unpaidList',//未缴费清单
        name: 'unpaidList',
        component: () => import('./views/Payment/contract-manage/unpaidList.vue')
    },
    //已缴金额 amountPaid
    {
        path: '/amountPaid',//已缴金额
        name: 'amountPaid',
        component: () => import('./views/Payment/contract-manage/amountPaid.vue')
    },
//扫码支付

  //租赁缴费 Rental payment
    
    //物业缴费 Property
    {
        path: '/proPerty',//物业缴费
        name: 'proPerty',
        component: () => import('./views/Payment/contract-manage/proPerty.vue'),
		meta: {
		      
		        type: 'login'  // 是否需要判断是否登录,这里是需要判断
		      }
    },
    //缴费主页

    //缴费主页

    {
        path: "/payHome",
        name: "payHome",
        component: () =>
            import("./views/home/Home-index.vue"),
		meta: {
		    
		        type: 'login'  // 是否需要判断是否登录,这里是需要判断
		      },
			  
			children:[
				{
				    path: '/MyHome',//我的用户
				    name: 'MyHome',
				    component: () => import('./views/Payment/User/MyHome.vue'),
					meta: {
					       
					        type: 'login'  // 是否需要判断是否登录,这里是需要判断
					      }
				},
				//用户列表
				{
				    path: '/UserList',//我的用户
				    name: 'UserList',
				    component: () => import('./views/Payment/User/UserList.vue'),
					meta: {
					        
					        type: 'login'  // 是否需要判断是否登录,这里是需要判断
					      }
				},
				{
				        path: "/index",
				        name: "index",
				        component: () => import('./views/Payment/User/indexs.vue'),
						meta: {
						       
						        type: 'login'  // 是否需要判断是否登录,这里是需要判断
						      }
				    },
				//用户公告
				{
				    path: "/UserAnnouncement",
				    name: "UserAnnouncement",
				    component: () => import('./views/Payment/User/UserAnnouncement.vue'),
					meta: {
					        
					        type: 'login'  // 是否需要判断是否登录,这里是需要判断
					      }
				},
				//公告详情
				{
				    path: "/AnnouncementDetail",
				    name: "AnnouncementDetail",
				    component: () => import('./views/Payment/User/AnnouncementDetail.vue'),
					meta: {
					       
					        type: 'login'  // 是否需要判断是否登录,这里是需要判断
					      }
				},
				//对账缴费 reconciLiation
				{
				    path: '/reconciLiation',//对账缴费
				    name: 'reconciLiation',
				    component: () => import('./views/Payment/contract-manage/reconciLiation.vue'),
					meta: {
					     
					        type: 'login'  // 是否需要判断是否登录,这里是需要判断
					      }
				},
				{
				    path: '/renTal',//租赁缴费
				    name: 'renTal',
				    component: () => import('./views/Payment/contract-manage/renTal.vue'),
					meta: {
					      
					        type: 'login'  // 是否需要判断是否登录,这里是需要判断
					      }
				},
				{
					path:'/paymentSaoma',
					name:'paymentSaoma',
					 component: () => import('./views/Payment/contract-manage/paymentSaoma.vue')
				},
				{
					path:'/paymentDuigong',
					name:'paymentDuigong',
					 component: () => import('./views/Payment/contract-manage/paymentDuigong.vue')
				},
			]
    },
	
	
    //水电缴费 hydropower
    {
        path: '/hydroPower',//水电缴费
        name: 'hydroPower',
        component: () => import('./views/Payment/contract-manage/hydroPower.vue'),
		meta: {
		     
		        type: 'login'  // 是否需要判断是否登录,这里是需要判断
		      }
    },
    //预缴费 Advance 
    {
        path: '/adVance',//预缴费
        name: 'adVance',
        component: () => import('./views/Payment/contract-manage/adVance.vue'),
		meta: {
		       
		        type: 'login'  // 是否需要判断是否登录,这里是需要判断
		      }
    },
    //全部账单缴费  ullBill
    {
        path: '/ullBill',//全部账单缴费
        name: 'ullBill',
        component: () => import('./views/Payment/contract-manage/ullBill.vue'),
		meta: {
		        
		        type: 'login'  // 是否需要判断是否登录,这里是需要判断
		      }
    },
    //欠款账单 arrEars
    {
        path: '/arrEars',//欠款账单
        name: 'arrEars',
        component: () => import('./views/Payment/contract-manage/arrEars.vue'),
		meta: {
		       
		        type: 'login'  // 是否需要判断是否登录,这里是需要判断
		      }
    },
    //定金缴费 dePosit 
    {
        path: '/dePosit',//定金缴费
        name: 'dePosit',
        component: () => import('./views/Payment/contract-manage/dePosit.vue'),
		meta: {
		       
		        type: 'login'  // 是否需要判断是否登录,这里是需要判断
		      }
    },
    
    //缴费确认
    {
        path: '/payConfirm',//对账缴费
        name: 'payConfirm',
        component: () => import('./views/Payment/contract-manage/payConfirm.vue')
    },
	
    
	// //用户列表
	// {
	//     path: '/userlists',//我的用户
	//     name: 'userlists',
	//     component: () => import('./views/Payment/User/userlists.vue')
	// },
    // 首页
    
    ]
});
